import gql from 'graphql-tag';

import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { SetConsentMutation, SetConsentMutationVariables } from './api.graphql';

export type ConsentInput = SetConsentMutationVariables['consentInput'];

export async function setConsent(
	{ text, name, consentGiven }: ConsentInput,
	{ gql: { fetch } }: UtilityContext,
): Promise<boolean> {
	const { data } = await fetch<SetConsentMutation, SetConsentMutationVariables>({
		query: gql`
			mutation SetConsent($consentInput: ConsentInput!) {
				respondToMarketingCommsConsentRequest(input: $consentInput) {
					success
				}
			}
		`,
		variables: {
			consentInput: {
				text, // eslint-disable-line @typescript-eslint/no-unsafe-assignment
				name,
				consentGiven,
			},
		},
	});
	return !!data?.respondToMarketingCommsConsentRequest.success;
}
